/* © 2016 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 2016
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

module.exports = function (config, get, post) {
	return {
		data: device_data,
		connection: device_connect,
		information: device_information,
		activity: {
			steps: {
				add: add_stepcount,
				history: get_cumulative
			}
		},
		bloodsugar: {
			add: add_bloodsugar,
			history: get_bloodsugarhistory
		},
		weight: {
			add: add_weight,
			history: get_weighthistory
		},
		bloodpressure: {
			add: add_bloodpressure,
			history: get_bloodpressurehistory
		},
		bloodoxygen: {
			add: add_bloodoxygen,
			history: get_bloodoxygenhistory
		},
		bodytemperature: {
			add: add_bodytemperature,
			history: get_bodytemperature_history
		},

		wander: {
			connects: wander_history_connect,
			disconnects: wander_history_disconnect,
			acknowledge: wander_history_acknowledge,
			invalid: wander_history_invalid,
		},
		fall: {
			invalid: fall_history_invalid,
			history: fall_history
		},
		track: {
			falls: fall_history
		},
		customIndicators: createCustomIndicators(config, get, post)
	};

	// Retrieves and adds a user's body temperature history
	function get_bodytemperature_history() {
		return get("/v2/observations/bodytemperature/history");
	}

	function add_bodytemperature(data) {
		return post("/v2/observations/bodytemperature/record", {
			temperature: data.temperature,
			units: data.units,
			comment: data.comment,
			manual: data.manual
		});
	}


	// Retrieves and adds a user's blood oxygen history
	function get_bloodoxygenhistory() {
		return get("/v2/observations/bloodoxygen/history");
	}

	function add_bloodoxygen(data) {
		return post("/v2/observations/bloodoxygen/record", {
			pulserate: data.pulserate,
			oxygensaturation: data.oxygensaturation,
			comment: data.comment,
			oxygen: data.oxygen,
			exertion: data.exertion,
			manual: data.manual
		});
	}

	// Retrieves and adds a user's blood pressure history
	function get_bloodpressurehistory() {
		return get("/v2/observations/bloodpressure/history");
	}

	function add_bloodpressure(data) {
		return post("/v2/observations/bloodpressure/record", {
			systolic: data.systolic,
			diastolic: data.diastolic,
			bpPulserate: data.bpPulserate,
			comment: data.comment,
			manual: data.manual
		});
	}

	// Retrieves a user's weight history
	function get_weighthistory() {
		return get("/v2/observations/weight/history");
	}
	// Adds a new measurement to a user's weight history
	function add_weight(data) {
		return post("/v2/observations/weight/record", {
			weight: data.weight,
			units: data.units,
			comment: data.comment,
			manual: data.manual
		});
	}

	/**
	 * Retrieves the Users glucose history
	 */
	function get_bloodsugarhistory() {
		return get("/v2/observations/bloodsugar/history");
	}

	/**
	 * A call to add a new bloodsugar reading to database
	 */
	function add_bloodsugar(data) {
		return post("/v2/observations/bloodsugar/record", {
			meanblood: data.meanblood,
			glucose: data.glucose,
			units: data.units,
			comment: data.comment,
			manual: data.manual,
			timestamp: data.timestamp
		});
	}

	/**
	 * A call to add an entry to the step count database
	 */
	function add_stepcount(data) {
		return post("/v2/observations/steps", {
			value: data.value,
			timestamp: data.timestamp,
			comment: data.comment,
			manual: data.manual
		});
	}

	function get_cumulative(user) {
		return get("/v2/observations/steps/cumulative", {
			managee: user
		});
	}

	/**
	 * Registers a device connection event and causes it to be
	 * written to the db
	 * @param  {ObjectId} machine [description]
	 * @return {[type]}         [description]
	 */
	function device_connect(machine) {
		return post("/v2/device/connection", {
			machine: machine
		});
	}

	/**
	 * A call to retrieve the device data
	 * @return {[type]} [description]
	 */
	function device_data() {
		return get("/v2/device/data");
	}

	/**
	 * Registers a device connection event AFTER A DISCONNECT EVENT HAS
	 * OCCURED, and causes it to be written to the db.
	 * @param  {ObjectId} machine [description]
	 * @return {[type]}         [description]
	 */
	function wander_history_connect(machine) {
		return post("/v2/device/track/connected", {
			machine: machine
		});
	}

	function wander_history_disconnect(machine) {
		return post("/v2/device/track/disconnected", {
			machine: machine
		});
	}

	function wander_history_acknowledge(from) {
		return post("/v2/device/track/acknowledge", {
			from: from
		});
	}

	function fall_history(mac, machine) {
		return post("/v2/device/track/falls", {
			mac: mac,
			machine: machine
		});
	}

	function wander_history_invalid(data) {
		var from = data.from;
		var falsealarm = data.falsealarm;
		return post("/v2/device/track/wanderInvalid", {
			from: from,
			falsealarm: falsealarm
		});
	}

	function fall_history_invalid(data) {
		var from = data.from;
		var falsealarm = data.falsealarm;
		return post("/v2/device/track/fallInvalid", {
			from: from,
			falsealarm: falsealarm
		});
	}

	function device_information(deviceInfo){
		return post("/v2/device/info/add", {
			deviceInformation: deviceInfo
		});
	}
};

function createCustomIndicators(config, get, post) {
	return {
		listAll: listAll,
		history: history,
		record: record
	};

	function listAll() {
		return get("/v2/observations/indicators");
	}

	function history(indicatorId) {
		return get(`/v2/observations/indicators/${indicatorId}/history`);
	}

	function record(indicatorId, value, comment) {
		return post(`/v2/observations/indicators/${indicatorId}/record`, {
			value: value,
			comment: comment
		});
	}
}
